import type {CSSObject, Theme} from '@mui/material/styles';
import {styled} from '@mui/material/styles';
import MuiDrawer from '@mui/material/Drawer';
import {DRAWER_WIDTH} from "./DrawerConstants.ts";

const openedMixin = (theme: Theme): CSSObject => ({
    width: DRAWER_WIDTH,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
});

const closedMixin = (theme: Theme): CSSObject => ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up('sm')]: {
        width: `calc(${theme.spacing(8)} + 1px)`,
    },
});

export const DrawerMenu = styled(MuiDrawer, {shouldForwardProp: (prop) => prop !== 'open'})(
    ({theme}) => ({
        width: DRAWER_WIDTH,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
        variants: [
            {
                props: ({open}) => open,
                style: {
                    ...openedMixin(theme),
                    '& .MuiDrawer-paper': openedMixin(theme),
                    '& svg.mithra-logo .letters': {
                        opacity: 1,
                        transition: theme.transitions.create(['opacity'], {
                            easing: theme.transitions.easing.easeOut,
                            duration: theme.transitions.duration.enteringScreen,
                        }),
                    },
                    '& svg.mithra-logo .symbol': {
                        transform: 'rotate(90deg)',
                        transformOrigin: ['194px', '195.5px'],
                        fill: '#4589FF',
                        transition: theme.transitions.create(['transform'], {
                            easing: theme.transitions.easing.sharp,
                            duration: theme.transitions.duration.enteringScreen,
                        }),
                    },
                },
            }, {
                props: ({open}) => !open,
                style: {
                    ...closedMixin(theme),
                    '& .MuiDrawer-paper': closedMixin(theme),
                    '& svg.mithra-logo .letters': {
                        opacity: 0,
                        transition: theme.transitions.create(['opacity'], {
                            easing: theme.transitions.easing.easeOut,
                            duration: theme.transitions.duration.enteringScreen,
                        }),
                    },
                    '& svg.mithra-logo .symbol': {
                        // fill: 'gray',
                        transform: 'rotate(0deg)',
                        transformOrigin: ['194px', '195.5px'],
                        transition: theme.transitions.create(['transform'], {
                            easing: theme.transitions.easing.sharp,
                            duration: theme.transitions.duration.enteringScreen,
                        }),
                    },
                },
            },
        ],
    }),
);